import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2ea22aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "reason"
}
const _hoisted_3 = {
  key: 2,
  class: "tablefoot"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("买入总计：")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("买入总计占金额比：")
const _hoisted_6 = {
  key: 4,
  class: "tablefoot"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("卖出总计：")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("卖出总计占金额比：")
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.data || []).length || (_ctx.data2 || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_ctx.Ms)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.Ms), 1))
              : _createCommentVNode("", true),
            ((_ctx.data || []).length)
              ? (_openBlock(), _createBlock(_component_Table, {
                  key: 1,
                  data: _ctx.data,
                  columns: _ctx.columns,
                  bordered: true,
                  pagination: false
                }, null, 8, ["data", "columns"]))
              : _createCommentVNode("", true),
            ((_ctx.data || []).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("span", null, [
                    _hoisted_4,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.TotalAmount1 > 10000 ? (_ctx.TotalAmount1 / 10000).toFixed(2) + '万' : _ctx.TotalAmount1) + "元", 1)
                  ]),
                  _createElementVNode("span", null, [
                    _hoisted_5,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.TotalRatio1.toFixed(2)) + "%", 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.data2 || []).length)
              ? (_openBlock(), _createBlock(_component_Table, {
                  key: 3,
                  data: _ctx.data2,
                  columns: _ctx.columns2,
                  bordered: true,
                  pagination: false
                }, null, 8, ["data", "columns"]))
              : _createCommentVNode("", true),
            ((_ctx.data2 || []).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", null, [
                    _hoisted_7,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.TotalAmount2 > 10000 ? (_ctx.TotalAmount2 / 10000).toFixed(2) + '万' : _ctx.TotalAmount2) + "元", 1)
                  ]),
                  _createElementVNode("span", null, [
                    _hoisted_8,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.TotalRatio2.toFixed(2)) + "%", 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_9, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}